"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M7.5 10.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M19 11a7.97 7.97 0 0 1-2 5.292l4.854 4.854a.5.5 0 0 1-.708.708l-4.854-4.855A8 8 0 1 1 19 11m-1 0a7 7 0 1 0-14 0 7 7 0 0 0 14 0"
  })]
}), 'ZoomIn');
//# sourceMappingURL=index.js.map